import { ApplicationState } from '@app/store'
import {
  IGlobalConfigurationState,
  selectConfiguration,
} from '@app/store/modules/global'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import SignsListPage from '../components/SignsListPage'
import {
  actionCreators,
  ISignsListState,
  selectError,
  selectFilterText,
  selectIsLoading,
  selectItems,
  selectOrderBy,
  selectSort,
  selectTotalItems,
} from '../modules/signsList'

export default connect(
  createStructuredSelector<
    ApplicationState,
    ISignsListState & IGlobalConfigurationState
  >({
    configuration: selectConfiguration(),
    error: selectError(),
    filterText: selectFilterText(),
    isLoading: selectIsLoading(),
    items: selectItems(),
    orderBy: selectOrderBy(),
    sortOrder: selectSort(),
    totalItems: selectTotalItems(),
  }),
  actionCreators,
)(SignsListPage)
